const messages = {
    en: {
        delivery: {
            surveys: {
                title: 'Surveys',
                subtitle: 'Surveys Management',
                labels: {
                    name: 'Name',
                    description: 'Description',
                    questions: 'Questions',
                    question: 'Question',
                    options: 'Options',
                    optionValue: 'OptionValue',
                    information: 'Survey Information'
                },
                rules: {
                    options: 'At least 2 options are required.',
                    questions: 'At least 1 question is required.'
                },
                creating: 'Creating Survey',
                showing: 'Showing Survey',
                editing: 'Survey Edition',
                deleting: 'Survey Deletion',
                response: {
                    send: 'Send survey',
                    thanks: 'Thank you for sending us your opinion!'
                },
                viewConfig: {
                    title: 'View settings',
                    subtitle: 'Configure survey options for each view.',
                    tabs: {
                        home: 'Home',
                        email: 'Email'
                    },
                    labels: {
                        enableSurvey: 'Enable survey',
                        selectSurvey: 'Select survey',
                        homeBannerTexts: 'Home banner texts',
                        bannerTitle: 'Title',
                        bannerBody: 'Body text',
                        bannerButtonText: 'Button text'
                    },
                    placeholders: {
                        selectSurvey: 'Select a survey',
                        bannerTitle: 'Your opinion matters!',
                        bannerBody: 'Help us improve your experience by answering a short survey.',
                        bannerButtonText: 'ANSWER SURVEY'
                    },
                    buttons: {
                        save: 'Save changes',
                        saved: 'Changes saved'
                    },
                    rules: {
                        required: 'This field is required'
                    },
                    errors: {
                        preload: 'Something went wrong while loading the settings.',
                        surveys: 'Something went wrong while loading the surveys.',
                        save: 'Something went wrong while saving the changes.'
                    }
                }
            }
        }
    },
    es: {
        delivery: {
            surveys: {
                title: 'Encuestas',
                subtitle: 'Gestión de Encuestas',
                labels: {
                    name: 'Nombre',
                    description: 'Descripción',
                    questions: 'Preguntas',
                    question: 'Pregunta',
                    options: 'Opciones',
                    optionValue: 'Valor de opción',
                    information: 'Información de la encuesta'
                },
                rules: {
                    options: 'Se requieren almenos 2 opciones.',
                    questions: 'Se requiere almenos 1 pregunta.'
                },
                creating: 'Creación de encuesta',
                showing: 'Visualización de encuesta',
                editing: 'Edición de encuesta',
                deleting: 'Eliminación de encuesta',
                response: {
                    send: 'Enviar encuesta',
                    thanks: '¡Gracias por enviarnos tu opinión!'
                },
                viewConfig: {
                    title: 'Configuración de vistas',
                    subtitle: 'Configura las opciones de encuesta para cada vista.',
                    tabs: {
                        home: 'Home',
                        email: 'Email'
                    },
                    labels: {
                        enableSurvey: 'Habilitar encuesta',
                        selectSurvey: 'Seleccionar encuesta',
                        homeBannerTexts: 'Textos del banner de la home',
                        bannerTitle: 'Título',
                        bannerBody: 'Cuerpo del texto',
                        bannerButtonText: 'Texto del botón'
                    },
                    placeholders: {
                        selectSurvey: 'Selecciona una encuesta',
                        bannerTitle: '¡Tu opinión importa!',
                        bannerBody: 'Ayudanos a mejorar tu experiencia respondiendo una breve encuesta.',
                        bannerButtonText: 'RESPONDER ENCUESTA'
                    },
                    buttons: {
                        save: 'Guardar cambios',
                        saved: 'Cambios guardados'
                    },
                    rules: {
                        required: 'Este campo es requerido'
                    },
                    errors: {
                        preload: 'Ups! Algo salió mal al intentar precargar los datos de configuración.',
                        surveys: 'Ups! Algo salió mal al intentar traer los datos de las encuestas.',
                        save: 'Ups! Algo salió mal al intentar guardar los cambios.'
                    }
                }
            }
        }
    },
    pt: {
        delivery: {
            surveys: {
                title: 'Pesquisas',
                subtitle: 'Gerenciamento de Pesquisas',
                labels: {
                    name: 'Nome',
                    description: 'descrição',
                    questions: 'Questões',
                    question: 'pergunta',
                    options: 'Opções',
                    optionValue: 'Valor da opção',
                    information: 'Informações da Pesquisa'
                },
                rules: {
                    options: 'Es requerido dos opciones.',
                    perguntas: 'Pelo menos 1 pergunta é necessária.'
                },
                creating: 'Criação de Pesquisa',
                showing: 'Mostrando Pesquisa',
                editing: 'Edição de Pesquisa',
                deleting: 'Exclusão de pesquisa',
                response: {
                    send: 'Enviar pesquisa',
                    thanks: 'Obrigado por nos enviar sua opinião!'
                },
                viewConfig: {
                    title: 'Configuração de visualizações',
                    subtitle: 'Configure as opções de pesquisa para cada visualização.',
                    tabs: {
                        home: 'Home',
                        email: 'Email'
                    },
                    labels: {
                        enableSurvey: 'Habilitar pesquisa',
                        selectSurvey: 'Selecionar pesquisa',
                        homeBannerTexts: 'Textos do banner da home',
                        bannerTitle: 'Título',
                        bannerBody: 'Texto do corpo',
                        bannerButtonText: 'Texto do botão'
                    },
                    placeholders: {
                        selectSurvey: 'Selecione uma pesquisa',
                        bannerTitle: 'Sua opinião importa!',
                        bannerBody: 'Ajude-nos a melhorar sua experiência respondendo uma breve pesquisa.',
                        bannerButtonText: 'RESPONDER PESQUISA'
                    },
                    buttons: {
                        save: 'Salvar alterações',
                        saved: 'Alterações salvas'
                    },
                    rules: {
                        required: 'Este campo é obrigatório'
                    },
                    errors: {
                        preload: 'Algo deu errado ao carregar as configurações.',
                        surveys: 'Algo deu errado ao carregar as pesquisas.',
                        save: 'Algo deu errado ao salvar as alterações.'
                    }
                }
            }
        }
    }

}


export default messages
